//require('default-passive-events');
import React from "react";
import ReactDOM from "react-dom";
import UserPreference from "./UserPreference.js";
import { forEach, dropRight, drop, delay } from "lodash";
require('es6-promise/auto');

 // import "c3/c3.css";
// import "./css/charts.css";

var divcollection = [];
var acuStyles = `https://aculist-widget-assets.azureedge.net/aculitWidgetStyles.css?v=1.0`;
window.userPrefFetched = false;
window.userpreferStore = [
  {
    BIUsername: "localhost",
    BIUserId: "1458118",
    AttributeKey: "vEmail",
    AttributeValue: "tproschold@serenogroup.com"
  },
  {
    BIUsername: "localhost",
    BIUserId: "1458118",
    AttributeKey: "vPrimColor",
    AttributeValue: "RGB(86,108,17)"
  },
  {
    BIUsername: "localhost",
    BIUserId: "1458118",
    AttributeKey: "vSecColor",
    AttributeValue: "RGB(208,111,32)"
  },
  {
    BIUsername: "localhost",
    BIUserId: "1458118",
    AttributeKey: "vSecColor1",
    AttributeValue: "RGB(0,0,0)"
  },
  {
    BIUsername: "localhost",
    BIUserId: "1458118",
    AttributeKey: "vTextColor",
    AttributeValue: "RGB(0,0,0)"
  }
];
var defaultClassType="Residential - Single Family,Residential - Common Interest";
var defaultPeriodType="Year";
var defaultPeriod="10";

var aculistfetchMore = function() {
  userPrefFetched = true;
  drop(divcollection).map(widgetdiv => {
    var widgetselections = {
      geographytype: "",
      geographyvalue: "",
      classtype: typeof widgetdiv.dataset["classtype"]==='undefined'?defaultClassType:widgetdiv.dataset["classtype"],
      measure: widgetdiv.dataset["measure"],
      periodtype:typeof widgetdiv.dataset["periodtype"]==='undefined'?defaultPeriodType:widgetdiv.dataset["periodtype"],
      period:typeof widgetdiv.dataset["period"]==='undefined'?defaultPeriod:widgetdiv.dataset["period"],
      geo: [widgetdiv.dataset["geo"]],
      divid: widgetdiv.id,
      title:widgetdiv.dataset["title"]
    };

    ReactDOM.render(
      <UserPreference
        widgetselections={widgetselections}
        assets=""
        userpreferStore={userpreferStore}
      />,
      document.getElementById(widgetdiv.id)
    );
  });
};

function injectStyles(filename) {
  var fileref = document.createElement("link");
  fileref.setAttribute("rel", "stylesheet");
  fileref.setAttribute("type", "text/css");
  fileref.setAttribute("href", filename);
  fileref.onload = function() {
    AculistStylesInjected();
  };

  document.getElementsByTagName("head")[0].appendChild(fileref);
}

(function() {
  if (typeof window.CustomEvent === "function") return false

  function CustomEvent(event, params) {
    params = params || { bubbles: false, cancelable: false, detail: undefined }
    var evt = document.createEvent("CustomEvent")
    evt.initCustomEvent(event, params.bubbles, params.cancelable, params.detail)
    return evt
  }

  CustomEvent.prototype = window.Event.prototype

  window.CustomEvent = CustomEvent
})()
window.acculistFetch = new CustomEvent("acculistFetchMoreStuff");
document.body.addEventListener("acculistFetchMoreStuff",aculistfetchMore,false);

injectStyles(acuStyles);

document.getElementById("aculistWidgetRoot").classList.add("aculist");

forEach(document.getElementById("aculistWidgetRoot").querySelectorAll(".aculistwidget"), function(wdiv) {
  divcollection.push(wdiv);
});

function AculistStylesInjected() {
 
  dropRight(divcollection, divcollection.length - 1).map(widgetdiv => {

    var widgetselections = {
      geographytype: "",
      geographyvalue: "",
      classtype: typeof widgetdiv.dataset["classtype"]==='undefined'?defaultClassType:widgetdiv.dataset["classtype"],
      measure: widgetdiv.dataset["measure"],
        periodtype:typeof widgetdiv.dataset["periodtype"]==='undefined'?defaultPeriodType:widgetdiv.dataset["periodtype"],
      period:typeof widgetdiv.dataset["period"]==='undefined'?defaultPeriod:widgetdiv.dataset["period"], 
      geo: [widgetdiv.dataset["geo"]],
      divid: widgetdiv.id,
      title: widgetdiv.dataset["title"]
    };

    ReactDOM.render(
  
      <UserPreference
        widgetselections={widgetselections}
        assets=""
        userpreferStore={userpreferStore}
      />,
      document.getElementById(widgetdiv.id)
    );
  });
}



// WEBPACK FOOTER //
// ./src/indexmain.js